import { Model } from '@/models/Model';

export class Country extends Model {
  protected $name: string = 'Country';
  protected $endpoint: string = '/countries';
  protected $fillable: string[] = ['id', 'name', 'code'];

  public id?: string;
  public name?: string;
  public code?: string;
}
